import React from 'react';
import { LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import artistIntroLogo from '../../assets/artist_intro.svg';

interface DeactivatedScreenProps {
  message?: string;
  onSignOut: () => void;
}

const DeactivatedScreen: React.FC<DeactivatedScreenProps> = ({
  message = 'Your account is inactive. Please contact administrator.',
  onSignOut,
}) => {
  return (
    <div className="h-full flex flex-col bg-white rounded-2xl overflow-hidden">
      <div className="flex flex-col lg:grid lg:grid-cols-3 flex-1 min-h-0 overflow-hidden">
        {/* ─── Left Column: Content ───────────────── */}
        <div className="lg:col-span-3 flex flex-col flex-1 min-h-0 overflow-y-auto">
          {/* Logo pinned top */}
          <div className="shrink-0 px-6 sm:px-10 lg:px-16 pt-8 lg:pt-10">
            <img src={artistIntroLogo} alt="Artist Intro" className="h-10 shrink-0" />
          </div>

          {/* Vertically centered content */}
          <div className="flex-1 flex items-center px-6 sm:px-10 lg:px-16">
            <div className="max-w-2xl w-full">
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 leading-tight">
                Your account has been <span className="text-red-500">deactivated</span>
              </h1>

              <p className="text-gray-500 text-sm sm:text-base mb-1 leading-relaxed">
                {message}
              </p>
              <p className="text-gray-400 text-sm mb-8">
                If you think this is a mistake, please reach out to support.
              </p>

              <Button variant="primary" type="button" onClick={onSignOut}>
                <LogOut className="w-4 h-4 mr-2" />
                Sign Out
              </Button>
            </div>
          </div>
        </div>

        {/* ─── Right Column: Preview Panel ───────────────── */}
        {/* <div className="hidden lg:flex lg:col-span-2 bg-gray-100 border-l border-gray-100 rounded-tr-2xl rounded-br-2xl" /> */}
      </div>
    </div>
  );
};

export default DeactivatedScreen;
